import { Navigate } from 'react-router';
import Layout from '../layout-components/Layout';
import { routePaths } from '../../shared/config/globalConfig';
import { useSelector } from 'react-redux';
import Loader from '../layout-components/Loader';
import {
  AUTH_STATUS_AUTHENTICATED,
  AUTH_STATUS_BOOTSTRAPPING,
  AUTH_STATUS_REFRESHING,
} from '../../redux/types/user';
import { selectAuthStatus } from '../../redux/selectors/auth.selector';

// The `AuthRoute` component renders the provided `Component` within a `Layout` if the user is authenticated, and redirects to the home page if the user is not authenticated.
/**
 *
 * @returns {import('react').ReactElement}
 */
const AuthRoute = ({ component: Component }) => {
  const authStatus = useSelector(selectAuthStatus);
  const isAuthPending = [
    AUTH_STATUS_BOOTSTRAPPING,
    AUTH_STATUS_REFRESHING,
  ].includes(authStatus);

  return isAuthPending ? (
    <Loader isLoading />
  ) : authStatus === AUTH_STATUS_AUTHENTICATED ? (
    <Layout>
      <Component />
    </Layout>
  ) : (
    <Navigate to={routePaths.home} />
  );
};

export default AuthRoute;
